import { useDropdownOptions } from "../hooks/useDropdownOptions";

interface DropdownSelectProps {
  listCode: string;
  value: string;
  onChange: (value: string) => void;
  regionId?: number | null;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  required?: boolean;
  id?: string;
}

export default function DropdownSelect({
  listCode,
  value,
  onChange,
  regionId,
  placeholder = "",
  className = "input",
  disabled = false,
  required = false,
  id,
}: DropdownSelectProps) {
  const options = useDropdownOptions(listCode, regionId);

  const currentInOptions = options.some((o) => o.value === value);

  return (
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={className}
      disabled={disabled}
      required={required}
    >
      {placeholder && <option value="">{placeholder}</option>}
      {!currentInOptions && value && (
        <option value={value} className="text-gray-400">
          {value}
        </option>
      )}
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  );
}
